import type { ToastItem, ToastOptions } from '~/stores/toaster'
import { useToasterStore } from '~/stores/toaster'

// This type matches the props expected by AppToaster component
type ToasterProps = Omit<ToastItem, 'id' | 'createdAt' | 'progress'>

export function useToaster() {
  const store = useToasterStore()

  /**
   * Display a toast notification
   */
  function show(props: ToasterProps, options?: ToastOptions) {
    console.log('[useToaster] show', props, options)
    return store.addToast(props, options)
  }

  return {
    show,
    clear: store.removeToast,
    clearAll: store.clearAll,
  }
}
